import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 1rem;
`;

export const LoadingContainer = styled.div`
  height: 100%;
  margin: auto;
`;

export const Padding = styled.div`
  min-height: 1rem;
  width: 1px;
`;
